import { render, staticRenderFns } from "./InactivityModal.vue?vue&type=template&id=0e748b38&"
import script from "./InactivityModal.vue?vue&type=script&lang=ts&"
export * from "./InactivityModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports